// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jJ_Q","newExpiryDate":"styles_newExpiryDate__3RtlS","footer":"styles_footer__2OJen"};